import { render, staticRenderFns } from "./AssetAdditions.vue?vue&type=template&id=0c307959&"
import script from "./AssetAdditions.vue?vue&type=script&lang=ts&"
export * from "./AssetAdditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c307959')) {
      api.createRecord('0c307959', component.options)
    } else {
      api.reload('0c307959', component.options)
    }
    module.hot.accept("./AssetAdditions.vue?vue&type=template&id=0c307959&", function () {
      api.rerender('0c307959', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Reports/AssetAdditions.vue"
export default component.exports